// extracted by mini-css-extract-plugin
export var anchor = "_53-0";
export var discard = "_53-4";
export var muiTooltipTooltip = "_53-6";
export var notificationBar = "_53-3";
export var saveButtonHoverSlotWrapper = "_53-5";
export var show = "_53-2";
export var spacer = "_53-1";